import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducers';
import { logger } from './middlewares';

export default function Store(persistedState) {
  return createStore(combineReducers({ ...reducers }), persistedState, applyMiddleware(logger, thunk));
}